import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import ManageEmailsContainer from './ManageEmailsContainer';
import UserInviteSuccessContainer from '../users/UserInviteSuccessContainer';
import UserInviteFormContainer from '../users/UserInviteFormContainer';
import SFTPFormContainer from './SFTPFormContainer';
import DialogForm from '../shared/DialogForm';

export default class AccountsPage extends React.Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    cancelDialogFunction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    toggleSelectAccount: PropTypes.func.isRequired,
    userInvite: PropTypes.object.isRequired,
    selectedAccountId: PropTypes.number,
    toggleDialogFunction: PropTypes.func.isRequired,
    viewUsersAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedAccountId: null,
  };

  handleClickViewUsers = account => () => {
    const { viewUsersAction } = this.props;
    viewUsersAction(account);
  };

  handleClickDialog = (account, id) => () => {
    const { toggleDialogFunction } = this.props;
    toggleDialogFunction(account, id);
  };

  renderAccounts = account => {
    const { toggleSelectAccount, selectedAccountId } = this.props;
    const isActive = selectedAccountId === account.id;
    return (
      <tr
        key={account.id}
        className={`hoverable ${isActive ? 'active' : ''}`}
        onClick={() => {
          toggleSelectAccount(account.id);
        }}
      >
        <td>{account.companyName}</td>
        <td>{account.status === 0 ? 'Disabled' : 'Enabled'}</td>
        <td>{account.accountTypeId}</td>
        <td>{account.city}</td>
        <td>{account.stateProvince}</td>
        <td>
          <Link to={`/superadmin/accounts/account/${account.id}`} className="btn btn-primary">
            Details
          </Link>
        </td>
        <td>
          <Link to={`/superadmin/accounts/edit/${account.id}`} className="btn btn-primary">
            Edit
          </Link>
        </td>
        <td>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.handleClickViewUsers(account)}
          >
            View & Edit Users
          </button>
        </td>
        <td>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.handleClickDialog(account, 'addUserDialog')}
          >
            Add User
          </button>
        </td>
        <td>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.handleClickDialog(account, 'addEmailsDialog')}
          >
            Manage Emails
          </button>
        </td>
        <td>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.handleClickDialog(account, 'sftpDialog')}
          >
            Modify SFTP Credentials
          </button>
        </td>
      </tr>
    );
  };

  renderInviteDialog = accountId => {
    const { cancelDialogFunction, userInvite, dialog, toggleDialogFunction } = this.props;
    return (
      <UserInviteFormContainer
        accountId={accountId}
        cancelDialogFunction={cancelDialogFunction}
        userInvite={userInvite}
        show={dialog.show}
        successFunction={toggleDialogFunction}
      />
    );
  };

  renderSuccessDialog = () => {
    const { cancelDialogFunction, userInvite, dialog, toggleDialogFunction } = this.props;
    return (
      <UserInviteSuccessContainer
        cancelDialogFunction={cancelDialogFunction}
        userInvite={userInvite}
        show={dialog.show}
        successFunction={toggleDialogFunction}
      />
    );
  };

  renderCCEmailsDialog = accountId => {
    const { cancelDialogFunction, dialog } = this.props;

    const dialogContent = (
      <ManageEmailsContainer accountId={accountId} cancelFunction={cancelDialogFunction} />
    );

    return (
      <DialogForm
        cancelFunction={cancelDialogFunction}
        cancelText="Close"
        content={dialogContent}
        id="addEmailsDialog"
        show={dialog.show}
        title="Add Emails to Account"
      />
    );
  };

  renderSTFPDialog = accountId => {
    const { cancelDialogFunction, dialog } = this.props;

    const dialogContent = (
      <SFTPFormContainer accountId={accountId} admin cancelFunction={cancelDialogFunction} />
    );

    return (
      <DialogForm
        cancelFunction={cancelDialogFunction}
        cancelText="Close"
        content={dialogContent}
        id="sftpDialog"
        show={dialog.show}
        title="Modify SFTP Credentials"
      />
    );
  };

  render() {
    const { accounts, userInvite, dialog } = this.props;

    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Status</th>
                  <th>Type</th>
                  <th>City</th>
                  <th>State</th>
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>{accounts.map(this.renderAccounts)}</tbody>
            </table>
          </div>
        </div>
        {dialog.id === 'addUserDialog' && dialog.show
          ? this.renderInviteDialog(dialog.accountId)
          : null}
        {userInvite.hasSecond &&
        userInvite.isSecond &&
        (dialog.id === 'successDialog' && dialog.show)
          ? this.renderSuccessDialog()
          : null}
        {dialog.show && dialog.id === 'sftpDialog' ? this.renderSTFPDialog(dialog.accountId) : null}
        {dialog.show && dialog.id === 'addEmailsDialog'
          ? this.renderCCEmailsDialog(dialog.accountId)
          : null}
      </div>
    );
  }
}
